import React, { useEffect, useState } from "react";
import MPaper from "Utils/Helpers/MPaper";
import MPageImage from "Utils/Helpers/MPageImage";
import AddHomeData from "./components/Add";
import TableHomeData from "./components/Table";
import { Grid2 } from "@mui/material";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { get_site_data } from "http/components/SiteData";
import { setHomeData } from "../../../../Redux/slices/mngrSlice";
import { useDispatch, useSelector } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { readToken } from "Utils/Helpers/Token";

export default function HomeData() {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [image, setImage] = useState(null);
  const { home } = useSelector((state) => ({
    home: state.mngr.home,
  }));

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (home) getData();
  }, [home]);

  const getData = async () => {
    dispatch(HandleLoading(true));
    const response = await get_site_data(71235);
    if (CheckApiStatus(response)) {
      setData(response.data.infos);
      setImage(response.data.image);
    }
    dispatch(setHomeData(false));
    dispatch(HandleLoading(false));
  };

  return (
    <>
      <Grid2 container spacing={2}>
        <Grid2 item size={{ lg: 5, md: 6, sm: 6, xs: 12 }}>
          <MPaper
            label={"New section"}
            content={<AddHomeData />}
            className="h-100"
          />
        </Grid2>
        <Grid2 item size={{ lg: 3, md: 4, sm: 6, xs: 12 }}>
          <MPaper
            label={"Page Image"}
            content={<MPageImage image={image} page={"home"} />}
            className="h-100"
          />
        </Grid2>
        <Grid2 item size={{ xs: 12 }}>
          <MPaper
            label={"Sections list"}
            content={<TableHomeData data={data} />}
            defaultExpanded={true}
          />
        </Grid2>
      </Grid2>
    </>
  );
}
